import React from "react";
import Map from "./Map";

function OperationalMap() {
  return (
    <div className="w-full relative h-full">
      <Map />
    </div>
  );
}

export default OperationalMap;
